import Api from '../../utils/axios';
export const classesData = async () => {
  try {
    return await Api.get('/classes', {});
  } catch (error) {
    return {
      status: 404,
    };
  }
};

export const classbyId = async (classId) => {
  try {
    const classes = await Api.get('/classes', {});

    const classData = classes.data?.data?.find((classes) => classes.id === classId);

    if (classData) {
      return {
        status: 200,
        data: classData,
      };
    } else {
      return {
        status: 404,
        message: 'Class not found',
      };
    }
  } catch (error) {
    return {
      status: 404,
    };
  }
};
